<!-- @format -->

<register-company-confirm-tag>
  <register-company-complete-tag
    if="{state.isComplete}"
    fetchApplyingData="{props.fetchApplyingData}"
  ></register-company-complete-tag>

  <template if="{!state.isComplete}">
    <div class="contents">
      <section class="contents_area">
        <div class="container_heading">
          <h1 class="heading-01 heading_application">入力内容の確認</h1>
          <ul class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
            </li>
            <li class="breadcrumb-item">
              <a onclick="{ back }">法人申請</a>
            </li>
            <li class="breadcrumb-item">入力内容の確認</li>
          </ul>
        </div>
        <!--/.container_heading-->

        <div class="lead_block">
          <p>
            以下の内容で法人申請を行います。
            <br />
            入力いただいた内容に誤りがないかご確認の上、「上記内容で申請」ボタンをクリックしてください。
          </p>
        </div>
        <!--/.lead_block-->

        <div class="contents_block">
          <form class="application_form">
            <company-detail
              before="{ props.before }"
              data="{ props.params }"
              prefs="{ props.prefs }"
            ></company-detail>

            <div class="checkbox_wrap">
              <input
                type="checkbox"
                name="privacy"
                id="privacy"
                class="checkbox-input js-check"
                onclick="{ onCheck }"
              />
              <label for="privacy" class="checkbox-parts">
                <a
                  target="_blank"
                  href="https://cro-co.co.jp/privacypolicy/agreement/"
                >
                  CROCO株式会社の個人情報の取り扱い
                </a>
                に同意する
              </label>
            </div>

            <div class="container_button">
              <button
                class="button button-clear"
                type="button"
                value="戻る"
                data-target=""
                onclick="{ back }"
              >
                戻る
              </button>
              <button
                name="submit"
                class="button button-primary button_checked"
                type="button"
                value="上記内容で申請"
                data-target=""
                onclick="{ submit }"
                disabled
              >
                上記内容で申請
              </button>
            </div>
            <!--/.container_button-->
          </form>
          <!--/.application_form-->
        </div>
        <!--/.contents_block-->
      </section>
      <!--/.contents_area-->
    </div>
    <!--/.contents-->
  </template>

  <script>
    import di from "dependency-injection";
    import routes from "@model/menu-routes.js";
    import registerCompanyCompleteTag from "@tags/pages/menu/register-company-complete.riot";
    import detail from "@tags/parts/company-detail.riot";

    export default {
      components: {
        "register-company-complete-tag": registerCompanyCompleteTag,
        "company-detail": detail,
      },
      state: {
        privacy: false,
        errorMessage: false,
        isComplete: false,
      },
      onBeforeMount() {
        this.routes = routes;
      },
      back() {
        this.props.back();
      },
      onCheck(e) {
        this.state.privacy = e.target.checked;
        this.$('button[name="submit"]').disabled = !this.state.privacy;
      },
      async submit() {
        if (!this.state.privacy) {
          di.toast.push("規約に同意して下さい。", "negative");
          this.update({ errorMessage: "規約に同意して下さい" });
          return;
        }

        try {
          const res = await this.props.MenuApi.request(
            "registerCompany",
            "register",
            { phase: "submit", ...this.props.params }
          );
          this.update({ isComplete: true });
          if (window.__INITIAL_PROPS__.company_type !== 2) {
            window.analytics.event("unlock_achievement", {
              achievement_id: "company_first_application",
            });
          }
        } catch (e) {
          this.update({ errorMessage: e.message });
        }
      },
    };
  </script>
</register-company-confirm-tag>
